import {createActions} from 'redux-actions';
import fetchJson, {putJson, putJsonWithResponse} from '../fetchJson';
import handleError from '../handleError';
import sessionActions from './session.actions';
import ReactGA from 'react-ga';
import notificationActions from './notifications.actions.js';

const actions = createActions(
	'CHAT_OPEN',
	'CHAT_RETRIEVING',
	'CHAT_RETRIEVED',
	'CHAT_MORE_RETRIEVED',
	'CHAT_RETRIEVED_FOR_SENDER',
	'CHAT_ADD_MESSAGES',
	'CHAT_MESSAGES_ADDED',
	'CHAT_SET_STATE',
	'CHAT_DISMISS'
);

const findExistingChat = (items, tempCode, tempCodeAlt) =>
	items.find(item => item.code === tempCode || item.code === tempCodeAlt);

export const retrieve = () => (dispatch, getState) => {
	dispatch(actions.chatRetrieving());
	fetchJson('/api/chat')
		.then(response => dispatch(actions.chatRetrieved(response)))
		.catch(handleError(dispatch));
};

export const retrieveMore = () => (dispatch, getState) => {
	const {nextOffset, more} = getState().chat;

	if (!more) return;

	fetchJson(`/api/chat?offset=${nextOffset}`)
		.then(response => dispatch(actions.chatMoreRetrieved(response)))
		.catch(handleError(dispatch));
};

export const open = recipientUserUuid => (dispatch, getState) => {
	const userUuid = getState().session.current.user.uuid;
	const {chat} = getState();

	ReactGA.event({
		category: 'Chat',
		action: 'Open'
	});

	const tempCode = `${userUuid}:${recipientUserUuid}`;
	const tempCodeAlt = `${recipientUserUuid}:${userUuid}`; // Can be flipped, depending on initiator

	// Let's see if it's a chat that we already have open.
	const existingChat = findExistingChat(chat.items, tempCode, tempCodeAlt);

	if (!existingChat) {
		// Attempt load/create from back-end
		putJsonWithResponse('/api/chat/' + recipientUserUuid)
			.then(chat => dispatch(actions.chatOpen(chat)))
			.catch(handleError(dispatch));
	}
};

export const sendMessage = (code, content, recipients) => (dispatch, getState) => {
	sessionActions.emit('chat.message.send', {
		recipients,
		content
	});

	ReactGA.event({
		category: 'Chat',
		action: 'Send message'
	});

	dispatch(
		actions.chatMessagesAdded({
			code,
			messages: [
				{
					content,
					createdAt: new Date().toISOString()
				}
			]
		})
	);
};

export const receiveMessage = ({content, createdAt, userUuid: senderUserUuid}) => (
	dispatch,
	getState
) => {
	const userUuid = getState().session.current.user.uuid;
	const {chat} = getState();

	const tempCode = `${userUuid}:${senderUserUuid}`;
	const tempCodeAlt = `${senderUserUuid}:${userUuid}`; // Can be flipped, depending on initiator

	// Let's see if it's a chat that we already have open.
	const existingChat = findExistingChat(chat.items, tempCode, tempCodeAlt);

	if (existingChat) {
		// If so, just add the new message
		dispatch(
			actions.chatMessagesAdded({
				code: existingChat.code,
				messages: [
					{
						content,
						createdAt,
						userUuid: senderUserUuid
					}
				]
			})
		);
	} else {
		// Otherwise we need full provider details, so just retrieve whole chat from backend
		fetchJson(`/api/chat/${senderUserUuid}`)
			.then(result => dispatch(actions.chatOpen(result)))
			.catch(handleError(dispatch));
	}
};

const getRecipientUuidFromChat = (chat, userUuid) =>
	chat.code
		.split(userUuid)
		.join('')
		.split(':')
		.join('');

export default {
	...actions,
	open,
	retrieve,
	retrieveMore,
	sendMessage,
	receiveMessage
};



// WEBPACK FOOTER //
// ./src/user/chat.actions.js